import React, { useRef, useState } from 'react';
import { IconButton, SearchIcon } from '@forgeglobal/design-framework';
import Search from '@tcs/client-portal-common/components/molecules/Search';
import useSearch from '@tcs/client-portal-common/hooks/useSearch';
import { SearchInputType } from '@tcs/client-portal-common/components/molecules/Search/types';
import useStyles from './style';
import usePanel from '@tcs/common/hooks/usePanel';

interface SearchBarProps {
  savedItemsKey: string;
  type: SearchInputType;
}

const SearchBar = ({ savedItemsKey, type }: SearchBarProps) => {
  const classes = useStyles(undefined);
  const ref = useRef(null);
  const [openPanel, setOpenPanel] = usePanel(ref);

  const [searchValue, setSearchValue] = useState('');
  const { data, loading } = useSearch(
    searchValue,
    undefined,
    undefined,
    undefined,
    false,
    true
  );

  return (
    <>
      <div className={classes.desktopSearch}>
        <Search
          onSearch={(val) => setSearchValue(val)}
          items={data}
          savedKey={savedItemsKey}
          loading={loading}
          type={type}
        />
      </div>
      <div className={classes.searchButton}>
        <IconButton onClick={() => setOpenPanel(true)}>
          <SearchIcon />
        </IconButton>
      </div>
      {openPanel && (
        <div className={classes.mobileSearch} ref={ref}>
          <Search
            onSearch={(val) => setSearchValue(val)}
            items={data}
            savedKey={savedItemsKey}
            loading={loading}
            type={type}
            inputClassName={classes.mobileSearchInput}
          />
        </div>
      )}
    </>
  );
};

export default SearchBar;
